import Account from './Account';
import Animal from './Animal';
import Armchair from './Armchair';
import Basket from './Basket';
import BathTub from './BathTub';
import BigDrill from './BigDrill';
import Brush from './Brush';
import BurgerMenu from './BurgerMenu';
import Close from './Close';
import Drill from './Drill';
import FaucetWater from './FaucetWater';
import Flash from './Flash';
import Hammer from './Hammer';
import Hood from './Hood';
import Lamp from './Lamp';
import List from './List';
import MessageCircle from './MessageCircle';
import Phone from './Phone';
import Promo from './Promo';
import Promos from './Promos';
import Screw from './Screw';
import Search from './Search';
import Spinner from './Spinner';
import Wall from './Wall';
import WateringCan from './WateringCan';

import AccountB2B from './AccountB2B';
import BasketB2B from './BasketB2B';
import ListB2B from './ListB2B';

export default {
  Account: { b2c: Account, b2b: AccountB2B },
  Animal: { b2c: Animal },
  Armchair: { b2c: Armchair },
  Basket: { b2c: Basket, b2b: BasketB2B },
  BathTub: { b2c: BathTub },
  BigDrill: { b2c: BigDrill },
  Brush: { b2c: Brush },
  BurgerMenu: { b2c: BurgerMenu },
  Close: { b2c: Close },
  Drill: { b2c: Drill },
  FaucetWater: { b2c: FaucetWater },
  Flash: { b2c: Flash },
  Hammer: { b2c: Hammer },
  Hood: { b2c: Hood },
  Lamp: { b2c: Lamp },
  List: { b2c: List, b2b: ListB2B },
  MessageCircle: { b2c: MessageCircle },
  Phone: { b2c: Phone },
  Promo: { b2c: Promo },
  Promos: { b2c: Promos },
  Screw: { b2c: Screw },
  Search: { b2c: Search },
  Spinner: { b2c: Spinner },
  Wall: { b2c: Wall },
  WateringCan: { b2c: WateringCan },
};
